import { LANGUAGES } from "@/src/constants/other";
import { Collapse, Popover } from "antd";
import { Divide as Hamburger } from "hamburger-react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const Eng = require("../../Assets/Images/Icons/En.svg");
const ArrowBottom = require("../../Assets/Images/Icons/arrowBottom.svg");
const arrw = require("../../Assets/Images/Icons/arrw.svg");
const VietNam = require("../../Assets/Images/Icons/vietNam.svg");
const styles = require("./Menu.module.scss");

const MenuPresenter = () => {
  const { t, i18n } = useTranslation(["translation"]);
  const [isOpen, setOpen] = useState(false);
  const { Panel } = Collapse;
  const [scroll, setScroll] = useState(false);
  const [translate, setTranslate] = useState(false);
  const [isHovering, setIsHovered] = useState(false);
  const onMouseEnter = () => setIsHovered(true);
  const onMouseLeave = () => setIsHovered(false);

  const handleScroll = () => {
    window.scrollY >= 10 ? setScroll(!0) : setScroll(!1);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={scroll ? styles.menuHeadActive : styles.menuHead}>
      <div className={scroll ? styles.menuActive : styles.menu}>
        <div className={styles.menu__container}>
          <div className={styles.menu__container__item}>
            <div className={styles.menu__container__item__images}>
              <Link href="/" prefetch={false}>
                <div className="logocus"></div>
              </Link>
            </div>
            <div className={styles.menu__container__item__content}>
              <div className={styles.menu__container__item__content__flex}>
                <>
                  <Link href="" prefetch={false}>
                    <>
                      <Popover
                        className={styles.menu__container__item__content__box}
                        content={
                          <div className="pop">
                            <Link href="/service-engineering" prefetch={false}>
                              {`Engineering`}
                            </Link>
                            <Link href="/service-platform" prefetch={false}>
                              {`Platforms`}
                            </Link>
                            <Link href="/service-solution" prefetch={false}>
                              {`Solutions`}
                            </Link>
                            <Link
                              href="/service-cloud"
                              prefetch={false}
                            >{`Clouds`}</Link>
                          </div>
                        }
                        trigger="hover"
                        placement="bottom"
                      >
                        <p>{t("SERVICE")}</p>
                        <Image src={ArrowBottom} alt="" />
                      </Popover>
                    </>
                  </Link>
                  <Link href="/our-product" prefetch={false}>
                    {t("PRODUCT")}
                  </Link>
                </>
                <Link href="/news-video" prefetch={false}>
                  {t("BLOG")}
                </Link>
                <Link href="/career" prefetch={false}>
                  {t("CAREER")}
                </Link>
                <Link href="" prefetch={false}>
                  <>
                    <Popover
                      className={styles.menu__container__item__content__box}
                      content={
                        <div className="pop">
                          <Link href="/about" prefetch={false}>
                            {t("PURPOSE")}
                          </Link>
                          <Link href="/our-team" prefetch={false}>
                            {t("OUR_TEAM")}
                          </Link>
                        </div>
                      }
                      trigger="hover"
                      placement="bottom"
                    >
                      <p>
                        {t("ABOUT_US")}
                        <Image src={ArrowBottom} alt="ArrowRIght" />
                      </p>
                    </Popover>
                  </>
                </Link>
                <div
                  onClick={() => {
                    if (i18n.language === LANGUAGES.en) {
                      i18n.changeLanguage(LANGUAGES.vn);
                    } else if (i18n.language === LANGUAGES.vn) {
                      i18n.changeLanguage(LANGUAGES.en);
                    }
                    setTranslate(!translate);
                  }}
                  className="flag"
                >
                  {!translate ? (
                    <Image src={VietNam} alt="" />
                  ) : (
                    <Image src={Eng} alt="" />
                  )}
                </div>
                <Link href="/contact-us" prefetch={false}>
                  <button
                    className="button-color2"
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                  >
                    {t("CONTACT")}

                    {isHovering ? (
                      <Image src={arrw} alt="" />
                    ) : (
                      <Image src={arrw} alt="" />
                    )}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.menuMb}>
        <div className={styles.menuMb__container}>
          <div className={styles.menuMb__container__item__images}>
            <Link href="/" prefetch={false}>
              <div className="logocus"></div>
            </Link>
          </div>
          <div className={styles.menuMb__container__item__Icon}>
            <div className={styles.menuMb__container__item__Images}>
              <div
                onClick={() => {
                  if (i18n.language === LANGUAGES.en) {
                    i18n.changeLanguage(LANGUAGES.vn);
                  } else if (i18n.language === LANGUAGES.vn) {
                    i18n.changeLanguage(LANGUAGES.en);
                  }
                  setTranslate(!translate);
                }}
                className="flag"
              >
                {!translate ? (
                  <Image src={VietNam} alt="" />
                ) : (
                  <Image src={Eng} alt="" />
                )}
              </div>
            </div>
            <div className={styles.menuMb__container__item__menuBar}>
              <Hamburger
                toggled={isOpen}
                toggle={setOpen}
                direction="right"
                size={25}
              />
            </div>
          </div>
          <div
            className={
              isOpen
                ? styles.menuMb__container__item__contentActive
                : styles.menuMb__container__item__content
            }
          >
            <div
              onClick={() => setOpen(!isOpen)}
              className={
                isOpen
                  ? styles.menuMb__container__item__contentActiveBg
                  : styles.menuMb__container__item__content
              }
            ></div>
            <ul>
              <Link href="/" prefetch={false}>
                <Collapse
                  bordered={false}
                  expandIconPosition="end"
                  expandIcon={({ isActive }) => (
                    <Image src={ArrowBottom} alt="" />
                  )}
                  className={styles.menuMb__container__item__content__collap}
                >
                  <Panel
                    header={t("SERVICE")}
                    key="1"
                    className={
                      styles.menuMb__container__item__content__collap__title
                    }
                  >
                    <Link
                      prefetch={false}
                      href="/service-engineering"
                      className={
                        styles.menuMb__container__item__content__collap__sub
                      }
                    >
                      <li>{`Engineering`}</li>
                    </Link>
                    <Link
                      prefetch={false}
                      href="/service-platform"
                      className={
                        styles.menuMb__container__item__content__collap__sub
                      }
                    >
                      <li>{`Platforms`}</li>
                    </Link>

                    <Link
                      prefetch={false}
                      href="/service-solution"
                      className={
                        styles.menuMb__container__item__content__collap__sub
                      }
                    >
                      <li>{`Solutions`}</li>
                    </Link>
                    <Link
                      prefetch={false}
                      href="/service-cloud"
                      className={
                        styles.menuMb__container__item__content__collap__sub
                      }
                    >
                      <li>{`Clouds`}</li>
                    </Link>
                  </Panel>
                </Collapse>
              </Link>
              <Link href="/our-product" prefetch={false}>
                {t("PRODUCT")}
              </Link>
              <Link href="/news-video" prefetch={false}>
                {t("BLOG")}
              </Link>
              <Link href="/career" prefetch={false}>
                {t("CAREER")}
              </Link>
              <Link href="">
                <Collapse
                  bordered={false}
                  expandIconPosition="end"
                  expandIcon={({ isActive }) => (
                    <Image src={ArrowBottom} alt="" />
                  )}
                  className={styles.menuMb__container__item__content__collap}
                >
                  <Panel
                    header={t("ABOUT_US")}
                    key="1"
                    className={
                      styles.menuMb__container__item__content__collap__title2
                    }
                  >
                    <Link
                      prefetch={false}
                      href="/about"
                      className={
                        styles.menuMb__container__item__content__collap__sub
                      }
                    >
                      <li> {t("PURPOSE")}</li>
                    </Link>
                    <Link
                      prefetch={false}
                      href="/our-team"
                      className={
                        styles.menuMb__container__item__content__collap__sub
                      }
                    >
                      <li>{t("OUR_TEAM")}</li>
                    </Link>
                  </Panel>
                </Collapse>
              </Link>
              <p>
                <div
                  onClick={() => {
                    if (i18n.language === LANGUAGES.en) {
                      i18n.changeLanguage(LANGUAGES.vn);
                    } else if (i18n.language === LANGUAGES.vn) {
                      i18n.changeLanguage(LANGUAGES.en);
                    }
                    setTranslate(!translate);
                  }}
                  className="flag"
                >
                  {!translate ? (
                    <Image src={VietNam} alt="" />
                  ) : (
                    <Image src={Eng} alt="" />
                  )}
                </div>
              </p>
              <Link href="/contact-us" prefetch={false}>
                <button className="button-color2">
                  {t("CONTACT")} <Image src={arrw} alt="" />
                </button>
              </Link>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MenuPresenter;
